import React from 'react'

import Icon from '../../Icon'
import styles from './IconInfo.module.scss'

const IconInfo = ({ color, name, className }: { color: 'violet' | 'white'; name: string; className?: string }) => {
  return (
    <div className={`${styles.icon} ${styles[color]} ${className}`}>
      <Icon name={name} />
    </div>
  )
}

export default IconInfo
